module.exports = __webpack_public_path__ + "static/iron-workrs-e6bc68c131c287e5a5ce941892a73986.jpeg";